import React, {Component} from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import Datetime from 'react-datetime';
import {Alert, Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Row,} from 'reactstrap';

import {closeAlert} from '../../../actions/commonsActions';
import {USER_ROLES} from '../../../helpers/constants';
import Pagination from '../../Pagination/Pagination';
import {fetchCompanyStats, filteringCompanyStats} from '../../../actions/statsActions';
import {fetchCompanies} from '../../../actions/companyActions';
import {I18n} from "../../../I18n/components/statistics";

import 'react-datetime/css/react-datetime.css';
import 'react-table/react-table.css';
import './stores-stat.css';
import {isStatisticPermission} from "../../../helpers/companyService";
import swal from "sweetalert";

class StoresStat extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
			dateTo: moment().format('YYYY-MM-DD'),
			companyId: null
		};
	}

	componentDidMount() {
		if (!isStatisticPermission(this.props.companies[0], this.props.authority)) {
			swal(
				I18n[this.props.lang].general.contactUsToAccessThis,
				"",
				"error")
			return
		}
		(async () => {
			const companyId = this.props.match && this.props.match.params && this.props.match.params.companyid ?
				this.props.match.params.companyid : null;
			const urlParams = new URLSearchParams(window.location.search);
			const dateFrom = urlParams.has('dateFrom') ? urlParams.get('dateFrom') : null;
			const dateTo = urlParams.has('dateTo') ? urlParams.get('dateTo') : null;

			if (dateFrom && dateTo) {
				await this.setState({
					dateFrom : dateFrom,
					dateTo: dateTo
				});
			}

			try {
				// if (!companyId || this.props.companies[0]) {
				// 	await this.props.fetchCompanies();
				// }
				await this.props.fetchCompanyStats(companyId ? companyId : this.props.companies[0].id, {
					dateFrom: this.state.dateFrom,
					dateTo: this.state.dateTo
				});
			} catch (error) {
				console.log(error);
			}
            this.setState({
                companyId: companyId ? companyId : this.props.companies[0].id
            })
		})();
	}

    onFilterClick = event => {
        const value = event.target.value;
        this.props.filteringCompanyStats(value);
    };

	dateToTimeChange = moment => {
		this.setState({
			dateTo: moment.format('YYYY-MM-DD')
		})
	};

	dateFromTimeChange = moment => {
		this.setState({
			dateFrom: moment.format('YYYY-MM-DD')
		})
	};

	getFiltered = async () => {
		await this.props.fetchCompanyStats(this.state.companyId, {
			dateFrom: this.state.dateFrom,
			dateTo: this.state.dateTo
		});
	};

	clearFilters = () => {
		this.setState({
			dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
			dateTo: moment().format('YYYY-MM-DD'),
		}, async () => {
			await this.props.fetchCompanyStats(this.state.companyId, {
				dateFrom: this.state.dateFrom,
				dateTo: this.state.dateTo
			});
		})
	};

	render() {
		const {loading, lang} = this.props;
		console.log('loading', loading)
		return (
			<div className='stores-stats'>
				{/*----------------------- alerts -----------------------------------*/}
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>
				<Card>
					<CardTitle className="mb-0 p-3 border-bottom bg-light">
						<div>
							<i className="mdi mdi-border-right mr-2"></i>{I18n[lang].points.title}
						</div>
					</CardTitle>

					<CardBody>
						{
							(() => {
								if (loading) {
									return <div className="loading">Loading...</div>;
								} else {
                                    const stores = this.props.filteredStoresStats || this.props.storesStats;
									const tableData = stores.map(store => {
										return {
											id: store.salesPointId,
											name: store.salesPointName,
											// 	admin: store.admin,
											devices: store.totalDevices,
											apps: store.totalApps,
											store: store
										};
									});
									return (
										<div>
											<Row>
												<Col lg="12">
													<FormGroup>
														<Input
															className="stores-search-filter"
															type="text"
															name="search"
															id="search"
															value={this.state.login}
															onChange={this.onFilterClick}
															placeholder={I18n[lang].point.placeholder}
														/>
														<Datetime
															className="stores-data-filter"
															locale="en-gb"
															timeFormat={false}
															closeOnSelect={true}
															inputProps={{ placeholder: `${I18n[lang].point.dateFrom}`, readOnly:true }}
															onChange={this.dateFromTimeChange}
															value={this.state.dateFrom? moment(this.state.dateFrom).format('DD.MM.YYYY'): ''}
														/>
														<Datetime
															className="company-data-filter date-to"
															locale="en-gb"
															timeFormat={false}
															closeOnSelect={true}
															inputProps={{ placeholder: `${I18n[lang].point.dateTo}`, readOnly:true }}
															onChange={this.dateToTimeChange}
															value={this.state.dateTo ? moment(this.state.dateTo).format('DD.MM.YYYY'): ''}
														/>
                                                        <div className="company-btn__group">
															<Button
																color="primary"
																type="button"
																className="company-btn btn-filter"
																onClick={this.getFiltered}
															>
																{I18n[lang].point.filter}
															</Button>
															<Button
																color="primary"
																type="button"
																className="company-btn btn-clear"
																onClick={this.clearFilters}
															>
																{I18n[lang].point.resetFilter}
															</Button>
														</div>
													</FormGroup>
												</Col>
											</Row>
											<div className="stat-table">
												<ReactTable
													getProps={() => {
														return {
															style: {
																border: "none",
																padding: "5px"
															}
														};
													}}
													getTheadProps={() => {
														return {
															style: {
																boxShadow: "none",
																padding: "10px 0",
																fontWeight: "600"
															}
														};
													}}
													getTheadThProps={() => {
														return {
															style: {
																borderRight: "none"
															}
														};
													}}
													getTdProps={() => {
														return {
															style: {
																borderRight: "none",
																textAlign: "center"
															}
														};
													}}
													getTrProps={(state, rowInfo) => {
														return {
															onClick: () => {
																const {dateFrom, dateTo} = this.state;
																this.props.changeLocation(`/dashboard/statistics/stores/${rowInfo.row._original.store.salesPointId}/?cid=${this.state.companyId}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
															},
															style: {
																alignItems: "center"
															}
														};
													}}
													getNoDataProps={() => {
														return {
															style: {
																top: "100%"
															}
														};
													}}
													columns={[
														{
															Header: "#",
															accessor: "count_id",
															sortable: false,
															filterable: false,
															style: {
																textAlign: "left",
																fontSize: "0.7rem",
																textTransform: "lowercase"
															},
															maxWidth: 40,
															Cell: (row) => {
																return <div>{row.index + 1}</div>;
															}
														},
														{
															Header: `${I18n[lang].company.name}`,
															accessor: "name",
															sortable: false,
															filterable: false,
															minWidth: 200,
															style: {
																textAlign: "left"
															}
														},
														{
															Header: `${I18n[lang].company.devices}`,
															accessor: "devices",
															sortable: false,
															filterable: false,
															maxWidth: 110,
															style: {
																fontSize: "0.7rem",
																textAlign: "center"
															},
														},
														// {
														// 	Header: `${I18n[lang].company.apps}`,
														// 	accessor: "apps",
														// 	sortable: false,
														// 	filterable: false,
														// 	maxWidth: 110,
														// 	style: {
														// 		fontSize: "0.7rem",
														// 		textAlign: "center"
														// 	},
														// },
													]}
													PaginationComponent={Pagination}
													nextText={">>"}
													previousText={"<<"}
													minRows={0}
													pageSize={tableData.length}
													defaultPageSize={-1}
													showPaginationBottom={!!(tableData.length && tableData.length > 100)}
													className="-highlight"
													data={tableData}
													filterable
												/>
											</div>
										</div>
									)
								}
							})()
						}
					</CardBody>
				</Card>
			</div>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		closeAlert: () => dispatch(closeAlert()),
		changeLocation: (url) => dispatch(push(url)),
        fetchCompanies: (query) => dispatch(fetchCompanies(query)),
		fetchCompanyStats: (companyId, query) => dispatch(fetchCompanyStats(companyId, query)),
        filteringCompanyStats: word => dispatch(filteringCompanyStats(word)),
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	companies: state.companiesReducer.companies,
	authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
	stats: state.companyStatsReducer.companyStats,
    storesStats: state.companyStatsReducer.storesStats,
    filteredStoresStats: state.companyStatsReducer.filteredCompanyStats,
	loading: state.companyStatsReducer.loading,
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(StoresStat)



// WEBPACK FOOTER //
// ./src/components/Statistics/StoresStat/StoresStat.js